// src/components/Testimonials.js
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Testimonials.css";

function Testimonials() {
  const testimonials = [
    {
      id: 1,
      name: "John Doe",
      role: "Customer",
      image: "/assets/insta-1.jpg",
      text: "This is the best online store I’ve ever used. The products are top quality and delivery was super fast!",
    },
    {
      id: 2,
      name: "Sarah Smith",
      role: "Customer",
      image: "/assets/test-4.jpg",
      text: "Amazing experience! Great prices, easy checkout, and excellent customer service.",
    },
    {
      id: 3,
      name: "Michael Lee",
      role: "Customer",
      image: "/assets/test-3.jpg",
      text: "I love shopping here. The website is smooth and the products exceeded my expectations!",
    },
    {
      id: 4,
      name: "John Doe",
      role: "Customer",
      image: "/assets/insta-1.jpg",
      text: "This is the best online store I’ve ever used. The products are top quality and delivery was super fast!",
    },
    {
      id: 5,
      name: "Sarah Smith",
      role: "Customer",
      image: "/assets/test-4.jpg",
      text: "Amazing experience! Great prices, easy checkout, and excellent customer service.",
    },
    {
      id: 6,
      name: "Michael Lee",
      role: "Customer",
      image: "/assets/test-3.jpg",
      text: "I love shopping here. The website is smooth and the products exceeded my expectations!",
    },
  ];

  return (
    <section className="testimonials container-fluid px-md-5 py-5">
      <h2 className="section-title text-center mb-4">What Our Customers Say</h2>

      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop={true}
        spaceBetween={30}
        slidesPerView={1}
        breakpoints={{
          768: { slidesPerView: 2 },
          1200: { slidesPerView: 3 },
        }}
      >
        {testimonials.map((t) => (
          <SwiperSlide className="mb-5" key={t.id}>
            <div className="testimonial-card text-center p-4 shadow my-3">
              <img src={t.image} alt={t.name} className="testimonial-img" />
              <p className="testimonial-text mt-3">“{t.text}”</p>
              <h5 className="testimonial-name mt-3">{t.name}</h5>
              <span className="testimonial-role">{t.role}</span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default Testimonials;
